import debounce from "../helpers/custom-debounce";
import suggest from "./suggest";
import sendOnChange from "../helpers/sendOnChange";
import reg_keyboard from "../helpers/reg_keyboard";
import search_mask from "../helpers/search_mask";
import ignoreTypes from "../helpers/ignoreTypes";

function initAddressSearch() {

    const search_streets = document.querySelectorAll("#modal-address, #address-page-modal-address");
    search_streets.forEach(search_street => {
        let street = search_street.querySelector(".street-input");
        let plachelder_street = document.querySelector(".input_street");
        let streetInp = street;
        let street_id = "";

        let wrap = search_street.querySelector("#address-page-suggestions") || search_street.querySelector("#suggestions");

        let search_help = search_street.querySelector(".modal-address__info");
        let search_clear = search_street.querySelector(".modal-address__close");

        let result_start = search_street.querySelector(".search-address__proccess");
        let result_end = search_street.querySelector(".search-address__result");
        let result_bad = search_street.querySelector(".search-address__bad");
        let result_close = search_street.querySelectorAll(".close_result");

        if (result_close) {
            result_close.forEach(function (item) {
                item.addEventListener("click", function () {
                    result_start.style.display = "block";
                    result_end.style.display = "none";
                    result_bad.style.display = "none";
                });
            });
        }

        function closeTouch() {
            var el = document.querySelector("body");
            el.addEventListener("touchstart", swipeTouch, false);
        }

        function swipeTouch() {
            street.blur();
        }

        closeTouch();

        if (street) {
            street.addEventListener("input", debounce((e) => onChange(e), 500));

            function onChange(e) {
                if (e.target.value.length > 1) {
                    if (search_clear) search_clear.style.display = "flex";
                    wrap.style.display = "block";
                    let promise = suggest(e.target.value, street_id);
                    search_help.classList.add("hide");
                    promise
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (suggestions) {
                            wrap.innerHTML = "";
                            let hasStreetUrl = false;
                            for (let key in suggestions["suggestions"]) {
                                if (
                                    ignoreTypes[
                                        suggestions["suggestions"][key]["data"]
                                            .street_type
                                        ]
                                ) {
                                    continue;
                                }
                                // не показываем адреса без house_fias_id
                                if (suggestions["suggestions"][key]["data"]["house"] && suggestions["suggestions"][key]["data"].house_fias_id == null) {
                                    continue;
                                }

                                let street =
                                    suggestions["suggestions"][key]["data"][
                                        "street_with_type"
                                        ];
                                if (street) {
                                    let house =
                                        suggestions["suggestions"][key]["data"][
                                            "house"
                                            ];
                                    let stead= suggestions["suggestions"][key]["data"][
                                        "stead"
                                        ]
                                    let stead_type = suggestions["suggestions"][key]["data"][
                                        "stead_type"
                                        ]
                                    if (!house && stead) {
                                        house = stead_type + " " + stead;
                                    }
                                    let house_in =
                                        house === null ? "" : ", " + house;

                                    let house_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "house_fias_id"
                                            ];
                                    let street_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "street_fias_id"
                                            ];

                                    let block_type =
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ];
                                    if (
                                        block_type == "лит" ||
                                        block_type == "литер"
                                    )
                                        block_type = "";
                                    if (block_type == "стр")
                                        block_type = " " + block_type + " ";
                                    let block =
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ];
                                    block =
                                        block === null ? "" : block_type + block;

                                    let city =
                                        suggestions["suggestions"][key]["data"][
                                            "city"
                                            ];
                                    let region =
                                        suggestions["suggestions"][key]["data"][
                                            "region"
                                            ];
                                    let region_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "region_with_type"
                                            ] || "";
                                    let area_with_type =
                                        ". " +
                                        suggestions["suggestions"][key]["data"][
                                            "area_with_type"
                                            ] +
                                        ". " || "";
                                    let settlement_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "settlement_with_type"
                                            ] || "";

                                    let uniqueAddress = "";
                                    if (
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ] &&
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ]
                                    ) {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block"
                                                ];
                                    } else {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ];
                                    }

                                    if (city) {
                                        city =
                                            city == region
                                                ? region_with_type
                                                : city;
                                    } else {
                                        city =
                                            region_with_type +
                                            area_with_type +
                                            settlement_with_type;
                                    }

                                    if (settlement_with_type) {
                                        city += ", " + settlement_with_type;
                                    }

                                    region = '<div class="city">' + city + "</div>";

                                    if (house === null) {
                                        let div = document.createElement("div");
                                        div.innerHTML =
                                            '<div class="suggestions-item" data-id="' +
                                            street_fias_id +
                                            '"><div class="title suggestions__title">' +
                                            street +
                                            "</div>" +
                                            region +
                                            "</div>";
                                        wrap.append(div);
                                    } else {
                                        let div = document.createElement("div");
                                        div.innerHTML =
                                            '<div class="suggestions-item"><a href="#" class="js-select-house" data-fias="' +
                                            house_fias_id +
                                            '"></a><div class="title">' +
                                            street +
                                            house_in +
                                            block +
                                            "</div>" +
                                            region +
                                            "</div>";
                                        let el =
                                            div.querySelector(".js-select-house");
                                        el.addEventListener(
                                            "click",
                                            function (evt) {
                                                evt.preventDefault();

                                                let house_fias_id =
                                                    evt.target.dataset.fias;
                                                var clickedSuggesstion =
                                                    suggestions["suggestions"].find(
                                                        (sug) =>
                                                            sug.data
                                                                .house_fias_id ==
                                                            house_fias_id
                                                    );

                                                getUrl(
                                                    uniqueAddress,
                                                    clickedSuggesstion
                                                )
                                                    .then(function (response) {
                                                        return response.json();
                                                    })
                                                    .then(function (result) {
                                                        if (result.url) {
                                                            location.href =
                                                                result.url;
                                                        } else {
                                                            if (isSubdomain) {
                                                                location.href =
                                                                    "/internet-po-adresu/other-results";
                                                            } else {
                                                                location.href =
                                                                    `${citySlug}/internet-po-adresu/other-results`;
                                                            }
                                                        }
                                                    })
                                                    .catch(function (error) {
                                                        console.log(error);
                                                    });
                                            }
                                        );
                                        wrap.append(div);
                                    }

                                    let address_list =
                                        document.querySelectorAll(
                                            ".suggestions-item"
                                        );
                                    let processingPromise = null; // Храним текущий промис
                                    address_list.forEach(function (item, idx) {
                                        search_mask(
                                            item.querySelector(".suggestions__title"),
                                            reg_keyboard(e.target.value)
                                        );

                                        if (house === null) {
                                            item.onclick = function (evt) {
                                                streetInp.value =
                                                    item.querySelector(
                                                        ".suggestions__title"
                                                    ).textContent + " ";
                                                street_id =
                                                    item.getAttribute("data-id");
                                                sendOnChange(streetInp);
                                                streetInp.focus();
                                            };
                                        // TODO: NEED REFACTOR!
                                        } else {
                                            if (street_id && idx !== 0) {
                                                let house_fias_id = item.querySelector("a")?.dataset.fias;
                                                let firstSuggestion = suggestions["suggestions"].find(
                                                    (sug) => sug.data.house_fias_id == house_fias_id
                                                );

                                                if (firstSuggestion && !hasStreetUrl && !processingPromise) {
                                                    processingPromise = getUrl(uniqueAddress, firstSuggestion)
                                                        .then(function (response) {
                                                            if (!hasStreetUrl) {
                                                                return response.json();
                                                            }
                                                            return null;
                                                        })
                                                        .then(function (result) {
                                                            if (!hasStreetUrl && result && result.url) {
                                                                hasStreetUrl = true;
                                                                let street_url = result.url;
                                                                street_url = street_url.substring(0, street_url.lastIndexOf('/'));
                                                                let element = wrap.firstChild;

                                                                if (element && element.nodeType === Node.ELEMENT_NODE) {
                                                                    let link = document.createElement('a');
                                                                    link.href = street_url;
                                                                    link.appendChild(element.cloneNode(true));
                                                                    wrap.replaceChild(link, element);
                                                                }
                                                            }
                                                        })
                                                        .catch(function (error) {
                                                            console.log(error);
                                                        })
                                                        .finally(function () {
                                                            processingPromise = null;
                                                        });
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    if (plachelder_street) plachelder_street.value = e.target.value;
                } else {
                    search_help.classList.remove("hide");
                    wrap.innerHTML = "";
                    wrap.style.display = "none";
                    if (search_clear) search_clear.style.display = "none";
                    street_id = "";
                    if (plachelder_street) plachelder_street.value = "";
                }
            }

            function getUrl(unique_address, choosedSuggestion) {
                let request = {
                    isSubdomain: isSubdomain,
                    citySlug: citySlug,
                    unique_address: unique_address,
                };

                if (choosedSuggestion != undefined) {
                    let hwb = choosedSuggestion.data.house;

                    if (choosedSuggestion.block_type != null) {
                        hwb += choosedSuggestion.data.block_type;
                    }

                    if (choosedSuggestion.data.block != null) {
                        hwb += choosedSuggestion.data.block;
                    }

                    request.area = choosedSuggestion.data.area;
                    request.house_fias_id = choosedSuggestion.data.house_fias_id;
                    request.street_with_type =
                        choosedSuggestion.data.street_with_type;
                    request.house_with_block = hwb;
                    request.kladr = choosedSuggestion.data.city_kladr_id;
                    request.geo_lat = choosedSuggestion.data.geo_lat;
                    request.geo_lon = choosedSuggestion.data.geo_lon;
                }
                let serviceUrl = `/api/street_url/`;

                let params = {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(request),
                };
                return fetch(serviceUrl, params);
            }

            search_clear.onclick = function () {
                street.value = "";
                plachelder_street.value = "";
                street.focus();
                sendOnChange(street);
            };
        }
        // select address desktop

        if (street && street.value.trim().length > 0) {
            sendOnChange(street);
        }
    });
}

export default  initAddressSearch;
